import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
// Complete icon imports
import { LiaRupeeSignSolid } from "react-icons/lia";
import { RiFridgeLine } from "react-icons/ri";
import { FaWater } from "react-icons/fa";
import { TbAirConditioning } from "react-icons/tb";
import { CiWifiOn } from "react-icons/ci";
import { MdOutlineFreeBreakfast } from "react-icons/md";
import { PiTelevisionSimpleThin } from "react-icons/pi";
import { PiBuildingApartmentLight } from "react-icons/pi";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { LuBedDouble, LuBedSingle } from "react-icons/lu";
import Heading from "../components/common/Heading";
import SampleRoom from "../components/home/SampleRoom";

export const RoomDetails = () => {
  // Map string names to icon components
  const iconMapping = {
    LiaRupeeSignSolid,
    RiFridgeLine,
    FaWater,
    TbAirConditioning,
    CiWifiOn,
    MdOutlineFreeBreakfast,
    PiTelevisionSimpleThin,
    PiBuildingApartmentLight,
    FaIndianRupeeSign,
    LuBedDouble,
    LuBedSingle,
  };

  const [roomdetail, setRoomDetails] = useState(null); // Initialize as null since it will be an object
  const [sessionData, setSessionData] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [differenceInDays, setDifferenceInDays] = useState(0);

  const { id } = useParams();
  useEffect(() => {
    const sessionData = JSON.parse(sessionStorage.getItem("bookingDetails"));
    console.log("sessionData", sessionData);
    setSessionData(JSON.parse(sessionStorage.getItem("bookingDetails")));
  }, []);

  useEffect(() => {
    fetch(`https://api.bgmhotel.com/rooms/${id}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        setRoomDetails(json);
        console.log("setRoomDetails", json); // Set the fetched room data
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const navigate = useNavigate();
  const calculateDateDifference = (checkIn, checkOut) => {
    if (checkIn && checkOut) {
      const checkInDateObj = new Date(checkIn);
      const checkOutDateObj = new Date(checkOut);

      // Difference in milliseconds
      const differenceInMs = checkOutDateObj - checkInDateObj;

      // Convert milliseconds to days
      const daysDifference = differenceInMs / (1000 * 60 * 60 * 24);

      setDifferenceInDays(daysDifference);
    }
  };
  const storeDataIntoLocal = (event) => {
    event.preventDefault();

    // ;
    const storageData = {
      chaekIn: event.target.chekindate.value,
      chaekOut: event.target.chackoutdate.value,
      adults: event?.target?.adults?.value,
      child: event?.target?.child?.value,
      nights: differenceInDays,
    };
    console.log(storageData);
    // localStorage.setItem(storageData);
    sessionStorage.setItem("bookingDetails", JSON.stringify(storageData));
    // sessionStorage.setItem("nights", differenceInDays);
    navigate(`/rooms/${roomdetail.id}/booking`);
  };

  return roomdetail ? (
    <>
      <Heading
        // heading=`(Book Your${roomdetail.roomType})`
        heading={`Book Your ${roomdetail.roomType}`}
        title="Home"
        subtitle="Book Your Room"
      />
      <div>
        <div className="col-12 container py-4" id={roomdetail}>
          <h3 className="pt-4">{roomdetail.roomType}</h3>
          <h6>
            Book Your Stay at BGM Hotel & Restaurant - Where Comfort Meets
            Elegance
          </h6>
          <p>
            Your perfect getaway is just a booking away! At BGM Hotel &
            Restaurant, we offer a seamless and personalized booking experience,
            ensuring your journey begins with ease. Whether you're planning a
            romantic escape, a family vacation, or a business trip, our range of
            stylish and comfortable rooms is designed to meet all your needs.
          </p>
          <div className="row">
            <div
              className="col-lg-8 col-md-12 col-sm-12 carousel slide"
              id="carouselExampleIndicators"
            >
              <div className="carousel-inner">
                <div className="carousel-item active" data-bs-interval="3000">
                  <img
                    src={`https://api.bgmhotel.com${roomdetail.mainImage.url}`}
                    alt="Room"
                    className="d-block vh-75 w-100"
                  />
                  <div className="carousel-overlay"></div>
                  <div
                    className="carousel-caption d-none d-md-block"
                    data-aos="flip-right"
                    data-aos-duration="3000"
                  >
                    <h3>{roomdetail.description}</h3>

                    <h5 className="text-primary">
                      {iconMapping[roomdetail.price.icon] ? (
                        React.createElement(
                          iconMapping[roomdetail.price.icon]
                          // {
                          //   size: 24,
                          // }
                        )
                      ) : (
                        <span>{roomdetail.price.icon}</span>
                      )}
                      {roomdetail.price.label} / Night
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 bg-dark text-white">
              <form onSubmit={storeDataIntoLocal}>
                <div className="row">
                  <div className="col-6 gy-4 gx-4">
                    <label className="pb-3">CHECK IN</label>
                    {/* <input
                      className="form-control"
                      type="date"
                      disabled={sessionData}
                      value={sessionData ? sessionData.chaekIn : ""}
                    /> */}

                    <input
                      type="date"
                      className="form-control"
                      id="chekindate"
                      name="chekindate"
                      required
                      min={new Date().toISOString().split("T")[0]} // Disable past dates
                      value={sessionData ? sessionData.chaekIn : checkInDate}
                      disabled={sessionData}
                      onChange={(e) => {
                        setCheckInDate(e.target.value);
                        calculateDateDifference(e.target.value, checkOutDate);
                      }}
                    />
                  </div>
                  <div className="col-6 gy-4 gx-4">
                    <label className="pb-3">CHECK OUT</label>
                    {/* <input
                      className="form-control"
                      type="date"
                      disabled={sessionData}
                      value={sessionData ? sessionData.chaekOut : ""}
                    /> */}
                    <input
                      type="date"
                      className="form-control"
                      id="checkout"
                      name="chackoutdate"
                      required
                      min={
                        checkInDate || new Date().toISOString().split("T")[0]
                      } // Disable dates before check-in
                      value={sessionData ? sessionData.chaekOut : checkOutDate}
                      disabled={sessionData}
                      onChange={(e) => {
                        setCheckOutDate(e.target.value);
                        calculateDateDifference(checkInDate, e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-6 gy-4 gx-4">
                    <label className="pb-3">GUESTS</label>
                    {/* <input
                      className="form-control"
                      type="number"
                      disabled={sessionData}
                      value={sessionData ? sessionData.adults : ""}
                    /> */}
                    <input
                      type="text"
                      name="adults"
                      className="form-control"
                      placeholder="Number of Adults"
                      aria-describedby="btnGroupAddon2"
                      value={sessionData ? sessionData.adults : ""}
                      disabled={sessionData}
                      maxLength="2"
                      onInput={(e) =>
                        (e.target.value = e.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 6))
                      }
                    />
                  </div>
                  <div className="col-6 gy-4 gx-4">
                    <label className="pb-3">NIGHTS</label>
                    <input
                      className="form-control"
                      type="number"
                      // disabled={sessionData}
                      disabled
                      value={
                        sessionData ? sessionData.nights : differenceInDays
                      }
                    />
                  </div>
                  <div className="col-12">
                    {/* <NavLink to={`/rooms/${roomdetail.id}/booking`}>
                   
                      <button type = "submit" className="btn btn-sm btn-warning rounded py-2 px-4 mt-4 mb-4 col-lg-12 col-md-4 col-sm-12 text-center">
                        SUBMIT
                      </button>
                    </NavLink> */}

                    <button
                      type="submit"
                      className="btn btn btn-warning rounded py-2 px-4 mt-4 mb-4 col-lg-12 col-md-4 col-sm-12 text-center"
                    >
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* <div className="row"> */}
          <h3 className="pt-5">Most popular facilities</h3>
          <div className="col-12 p-3 facility">
            <div className="row">
              {roomdetail.facilities.map((facility, indexFaci) => (
                <div
                  className="col-lg-3 col-md col-sm-6 d-flex align-items-center pt-2"
                  key={indexFaci}
                >
                  <div className="me-2">
                    {iconMapping[facility.icon] ? (
                      React.createElement(iconMapping[facility.icon], {})
                    ) : (
                      <>{facility.icon} </>
                    )}
                  </div>
                  &nbsp;
                  <span> {facility.label}</span>
                </div>
              ))}
            </div>
          </div>
          {/* </div> */}
          <hr />
          <p className="pt-4 pb-4 justify">
            An ideal escape to spend your days off well, just for yourself or
            with friends, families, and your beloved one. Unbelievably spacious,
            private, and idyllic in the center of BGM HOTEL offers the finest
            luxury room accommodation, along with the spacious room sizes and
            swiming pool available.
          </p>
        </div>
      </div>
      <SampleRoom />
    </>
  ) : (
    <div className="text-center">
      <h2>Room not found</h2>
    </div>
  );
};
